import { buildProps } from '@ll-plus/utils'

import type { ExtractPropTypes } from 'vue'
import type DropdownButton from './dropdown-button.vue'
import type Dropdown from './dropdown.vue'

export interface DropdownItem {
  label?: string
  key?: string | number
  icon?: string
  color?: string
  disabled?: boolean
  type?: string
  subMenu?: DropdownItem[]
}

// 公共属性
const sharedProps = {
  dropdownItems: {
    type: Array as () => DropdownItem[],
    required: false,
  },
  overlayClassName: {
    type: String,
    default: '',
  },
} as const

export const dropdownProps = buildProps({
  ...sharedProps,
})

export const dropdownEmits = {
  claimSelected: (item: DropdownItem) => !!item,
}

export const dropdownButtonProps = buildProps({
  ...sharedProps,
  buttonLabel: {
    type: String,
    default: '',
  },
  icon: {
    type: String,
    default: '',
  },
})

export const dropdownButtonEmits = {
  claimSelected: (item: DropdownItem) => !!item,
}

// props
export type DropdownProps = ExtractPropTypes<typeof dropdownProps>
export type DropdownButtonProps = ExtractPropTypes<typeof dropdownButtonProps>

// emits
export type DropdownEmits = typeof dropdownEmits
export type DropdownButtonEmits = typeof dropdownButtonEmits

// 实例
export type DropdownInstance = InstanceType<typeof Dropdown>
export type DropdownButtonInstance = InstanceType<typeof DropdownButton>
